import { Component, Input } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { APIService } from 'api/module'
import { NotifyService } from 'common/util/services/notify.service'
import { GenerateProxiesRequest, MediaRootDetail } from 'elements-sdk'

@Component({
  templateUrl: './regenerateProxiesModal.component.pug',
})
export class RegenerateProxiesModalComponent {
  @Input() options: GenerateProxiesRequest
  @Input() root: MediaRootDetail
  @Input() type?: string
  input = ''

  constructor (
    public modalInstance: NgbActiveModal,
    private api: APIService,
    private translate: TranslateService,
    private notify: NotifyService,
  ) { }

  async start () {
    await this.api.mediaLibrary.generateProxies({
      generateProxiesRequest: this.options,
    })
    this.notify.info(this.translate.instant('Proxy files will be regenerated soon'))
    this.modalInstance.close()
  }
}
